/// <reference lib="webworker" />

import { Workbox } from "workbox-window";

import { isCacheEnabled } from "api/serviceWorker/common";

export async function registerServiceWorker(onUpdate: () => void) {
    registerFirebaseServiceWorker();
    registerCacheServiceWorker(onUpdate);
}

export function unregisterAllServiceWorkers(onUnregister: () => void) {
    if ("serviceWorker" in navigator) {
        navigator.serviceWorker.getRegistrations().then((registrations) => {
            const unregisterPromises = registrations.map((registration) =>
                registration.unregister()
            );
            Promise.all(unregisterPromises).then(() => {
                onUnregister();
            });
        });
    }
}

async function registerCacheServiceWorker(onUpdate: () => void) {
    if (!isCacheEnabled()) {
        return;
    }
    if ("serviceWorker" in navigator) {
        try {
            // Используем абсолютный путь для service worker чтобы избежать проблем с подпапками
            const wb = new Workbox("/service-worker.js");

            wb.addEventListener("installed", (event) => {
                if (event.isUpdate) {
                    onUpdate();
                }
            });

            wb.addEventListener("waiting", () => {
                //console.log("Service Worker готов к обновлению");
            });

            wb.addEventListener("controlling", () => {
                //console.log("Service Worker активирован");
            });

            wb.register().catch((error) => {
                // Дополнительная диагностика
                if (error.message && error.message.includes("MIME")) {
                    console.error("MIME type problem - check /service-worker.js");
                }
            });
        } catch (error) {
            console.error("Workbox create error:", error);
        }
    }
}

function registerFirebaseServiceWorker() {
    if ("serviceWorker" in navigator) {
        navigator.serviceWorker
            .register("/firebase-messaging-sw.js")
            .then(function (registration) {
                //console.log("Firebase Service Worker registration successful:", registration);
            })
            .catch(function (err) {
                console.error("Firebase Service Worker registration failed:", err);
            });
    }
}
